// housekeeping/data/mockData.js
export const workers = [
    { id: 1, name: 'Alice Johnson', role: 'Senior Housekeeper', initials: 'AJ', status: 'available' },
    { id: 2, name: 'Bob Smith', role: 'Housekeeper', initials: 'BS', status: 'busy' },
    { id: 3, name: 'Carol Davis', role: 'Cleaning Assistant', initials: 'CD', status: 'available' },
    { id: 4, name: 'David Wilson', role: 'Maintenance', initials: 'DW', status: 'off-duty' }
];

export const initialTasks = [
    {
        id: 1,
        title: 'Clean Service - Room 101',
        description: 'Deep cleaning including bathroom sanitization',
        location: 'Room 101',
        assignedTo: 1,
        priority: 'high',
        dueDate: '15/1/2024',
        estimatedTime: 45,
        status: 'pending'
    },
    // 
    {
        id: 2,
        title: 'Laundry Service - Room 205',
        description: 'Collect and wash bed linens',
        location: 'Room 205',
        assignedTo: 2,
        priority: 'medium',
        dueDate: '15/1/2024',
        estimatedTime: 30,
        status: 'completed'
    },
    {
        id: 3,
        title: 'Restock Supplies - Floor 3',
        description: 'Refill cleaning supplies and toiletries',
        location: 'Floor 3',
        assignedTo: 3,
        priority: 'low',
        dueDate: '14/1/2024',
        estimatedTime: 20,
        status: 'completed'
    }
];